import { render, staticRenderFns } from "./MinContact.vue?vue&type=template&id=714d646d&"
import script from "./MinContact.vue?vue&type=script&lang=js&"
export * from "./MinContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports